import CryptoJS from "crypto-js";

export const dataDecrypt = (value) => {
  try {
    const bytes = CryptoJS.AES.decrypt(value, process.env.REACT_APP_SECRETKEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.log("🚀 ~ file: data-decrypt.js:9 ~ dataDecrypt ~ error:", error);
  }
};